var _rect, _rect2, _g, _rect3, _g2, _rect4, _rect5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisqualifiedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 55,
    viewBox: "0 0 75 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.2594,
    width: 43.7963,
    height: 55,
    rx: 10,
    fill: "#B1CBF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 13.2407,
    width: 23.4259,
    height: 27.5,
    rx: 5,
    fill: "#7DA9E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4580_3867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 23.6109V26.2498M11.25 28.8887H11.2566M17.8472 26.2498C17.8472 29.8934 14.8936 32.847 11.25 32.847C7.60648 32.847 4.6528 29.8934 4.6528 26.2498C4.6528 22.6063 7.60648 19.6526 11.25 19.6526C14.8936 19.6526 17.8472 22.6063 17.8472 26.2498Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.8892,
    y: 12.2407,
    width: 25.4259,
    height: 29.5,
    rx: 6,
    fill: "#2F75DA",
    stroke: "white",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4580_3867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4167 23.6109V26.2498M60.4167 28.8887H60.4233M67.0139 26.2498C67.0139 29.8934 64.0602 32.847 60.4167 32.847C56.7731 32.847 53.8195 29.8934 53.8195 26.2498C53.8195 22.6063 56.7731 19.6526 60.4167 19.6526C64.0602 19.6526 67.0139 22.6063 67.0139 26.2498Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 21.3889,
    width: 16.2963,
    height: 4.07407,
    rx: 2.03704,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 31.5742,
    width: 12.2222,
    height: 4.07407,
    rx: 2.03704,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4580_3867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8333,
    height: 15.8333,
    fill: "white",
    transform: "translate(3.33334 18.3333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4580_3867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8333,
    height: 15.8333,
    fill: "white",
    transform: "translate(52.5 18.3333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisqualifiedIcon);
export default __webpack_public_path__ + "static/media/disqualifiedIcon.ce91c5a60f40883cb4fd847ec455e9a6.svg";
export { ForwardRef as ReactComponent };